import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type GameImageList = paths['/v4/game/{slug}/image/'];

const getGameImageList = createRequest<GameImageList>('/pc/v4/game/{slug}/image/');

export default getGameImageList;
